module.exports = __webpack_public_path__ + "static/media/inactive-mic-icon.c3f56ade.svg";